export default __webpack_public_path__ + "static/media/workout.2ccf0636.jpg";